import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { useCallback } from 'react';
import { PERMISSION_ALARM } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import AlarmForm from '../../components/Alarms/AlarmForm';
import { URL_ALARM } from '../../router/constants';

const addAlarmSearchSchema = z.object({
  customerId: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_authenticated/alarm/add')({
  validateSearch: addAlarmSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_ALARM, ['create'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'alarms.subpage.addAlarm',
        suffix: 'menu.alarms',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AddAlarmRoute,
});

function AddAlarmRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate({ to: URL_ALARM });
  }, [navigate]);

  return (
    <div>
      <AlarmForm customerId={search?.customerId || undefined} closeCallback={handleClose} />
    </div>
  );
}
